import Message from '@/core/message'

const eventMap = {
  REFRESH_ORDER_DETAIL: 'refresh order detail page',
  REFRESH_JOB_DETAIL: 'refresh job detail',
  REFRESH_PALLET_DETAIL: 'refresh pallet detail page',
  UPDATE_DO: 'update DO',
  REFRESH_RESOURCE_LIST_PAGE: 'refresh resource page',
  REFRESH_JOB_CONTENT: 'refresh job content',
  REFRESH_PALLET_PAGE: 'refresh pallet page',
  REFRESH_STACK_LIST: 'refresh stack list',
  REFRESH_SHIPMENT_DETAIL: 'refresh shipment detail page',
  REFRESH_SHIPMENT_BOL: 'refresh shipment bol page',
  REFRESH_SHIPMENT_TRUCK: 'refresh shipment truck page',
  REFRESH_STOCK_PAGE: 'refresh stock page'
}

const PagesMessage = new Message(eventMap)
export default PagesMessage
